import axios from "axios";
import { getAppBaseURL } from "./networkUtil";

const API_URLS = "/api/v1/";
const AXIOS_TIMEOUT = { timeout: 15 * 1000 * 60 };

const SERVER_BASE_URL = process.env.REACT_APP_URL + "/advisor/api/v1/";

const validateStatusFn = function (status) {
  return status >= 200 && status <= 422; // Treat status codes 200-299 as successful
};

const AxiosInstance = axios.create({
  baseURL: `${SERVER_BASE_URL}`,
  timeout: AXIOS_TIMEOUT,
  validateStatus: validateStatusFn,
});
/**
 * Request interceptor — dynamic baseURL rewrite.
 *
 * Most requests need the baseURL rewritten to include the active app-prefix
 * (e.g. /advisor/api/v1/ca/ or /advisor/api/v1/ra/) so that they are routed
 * to the correct backend application context.
 *
 * However, some API calls (e.g. getadvanceSettings / setadvanceSettings) already
 * build their full URL via getBaseURL(), which intentionally omits the app-prefix
 * because the advanced-settings endpoint is app-agnostic (shared across ca and ra).
 * Those callers pass `noAppBase: true` in the Axios config to skip this rewrite
 * and preserve the plain /advisor/api/v1/ base instead.
 */
AxiosInstance.interceptors.request.use((config) => {
  if (!config.noAppBase) {
    config.baseURL = getAppBaseURL();
  }
  return config;
});

// Reinitiate SSO when a 401 error occurs on any network request.
// Note: validateStatusFn treats status codes 200–422 as success,
// so 401 must be handled in the response interceptor.
// Redirecting to the home page ensures that all required network requests are triggered,
// as some(e.g., getPlant API) may not fire if we stay on the same page.
// We also need to restart the PKCE flow; without it, the code challenge is missing error occurs
// A full page reload will trigger SSO reinitialization.
AxiosInstance.interceptors.response.use((response) => {
  if (response.status === 401) {
    console.log("Axios error:", response);
    sessionStorage.clear();
    window.location.href = process.env.REACT_APP_REDIRECT_URI;
  }
  return response;
});

export const AxiosInstanceWithoutTimeout = axios.create({
  baseURL: `${getAppBaseURL()}${API_URLS.apiVersion}`,
});

export default AxiosInstance;
